import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import { SIMULATIONS_HEADER } from '@bo-constants/simulations';
import { Searchbar } from '@library/components/inputs';
import { SimulationRow } from '@bo-components/simulations/SimulationRow';
import { getSimSortValue } from '@bo-utils/simulations';
import { useSimulations } from '@bo-hooks/simulations/useSimulations';
import { useState } from 'react';

export interface SimulationsProps {
  gameId?: string;
  leagueId?: string;
}

export const Simulations = ({
  gameId = '',
  leagueId = ''
}: SimulationsProps) => {
  const {
    simulations = [],
    isSimulationsError,
    isSimulationsLoading
  } = useSimulations({
    gameId,
    leagueId
  });

  const [searchSimValue, setSearchSimValue] = useState('');

  if (isSimulationsLoading) {
    return <Loading loadingMessage="Loading Simulations" />;
  }

  const filteredSearchSimRows = !searchSimValue
    ? simulations
    : simulations?.filter((row) =>
        row.attributes.simulation_run_name
          ?.toUpperCase()
          .includes(searchSimValue.toUpperCase())
      );

  const sortedSimulations = [...filteredSearchSimRows]?.sort((a, b) => {
    const aValue = getSimSortValue(a);
    const bValue = getSimSortValue(b);

    return aValue - bValue;
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-row-reverse">
        <div className="w-80 shrink-0 justify-self-end">
          <Searchbar
            searchValue={searchSimValue}
            handleSearch={setSearchSimValue}
            disabled={false}
            placeholder="Search sims"
          />
        </div>
      </div>

      <Table>
        <div
          className="flex flex-col overflow-x-auto overscroll-x-none"
          data-testid="Simulations"
        >
          <TableHeader headers={SIMULATIONS_HEADER} />
          <TableBody>
            {!simulations?.length || isSimulationsError ? (
              <NoResults label="Use the search bar to search by Name or ID" />
            ) : (
              sortedSimulations?.map((simulation) => (
                <SimulationRow
                  gameId={gameId}
                  leagueId={leagueId}
                  key={simulation.id}
                  simulation={simulation}
                />
              ))
            )}
          </TableBody>
        </div>
      </Table>
    </div>
  );
};
